import React from 'react';
import Button from '@mui/material/Button';

const ProjectButton = ({ coverImg, title, handleToggle }) => {
  return (
    <Button
      onClick={handleToggle}
      style={{
        backgroundImage: `url(${coverImg})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundBlendMode: 'multiply',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        textShadow:
          '0px 0px 4px rgba(0, 0, 0, 1) , 0px 0px 20px rgba(0, 0, 0, 1) , 0px 0px 7px rgba(0, 0, 0, 1) , 0px 0px 7px rgba(0, 0, 0, 1)',
      }}
      className="h-40 md:!h-56 !border-solid !border-white-300 !border-4 !text-lg !rounded-xl !font-bold !text-white !shadow-[0_4px_30px_rgba(0,0,0,0.2)]"
      variant="gradient"
    >
      {title}
    </Button>
  );
};

export default React.memo(ProjectButton);
